// This is here to inject the styles to the 3rd party library
import "./DayPickerStyles.scss";
import "./glamcorner.datepick.scss";
import DayPicker, { DayModifiers } from "react-day-picker";

export { DayModifiers };
export default DayPicker;
